import React from "react";
import { Link } from "react-router-dom";
import "./alumni.scss";
import Table from "react-bootstrap/Table";

export const Alumni = () => {
  return (
    <>
      <div className="alumni-page">
        <center>
          <h1>EMERITUS STAFF & ACADEMIC ALUMNI</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>Alumni</h6>
        </div>
      </div>
      <div className="col-md-8 offset-md-2 alumni-body mtt">
        <center>
          <h1>PAST HEADS OF DEPARTMENT</h1>
          <p>
            The following members of academic staff have variously served as
            Head of Department, in the chronological order indicated below:
          </p>
        </center>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S/N</th>
              <th>Name</th>
              <th>Year</th>
            </tr>{" "}
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Prof. A.O. Evwaraye</td>
              <td>1978 – 1981</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Dr. S.S. Joshua</td>
              <td>1981 – 1983</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Dr. S.K. Adjepong</td>
              <td>1983 – 1985</td>
            </tr>{" "}
            <tr>
              <td>4</td>
              <td>Prof. A.O. Evwaraye</td>
              <td>1985 – 1987</td>
            </tr>{" "}
            <tr>
              <td>5</td>
              <td>Dr. C.O. Ofeoegbu</td>
              <td>1987 - 1989</td>
            </tr>{" "}
            <tr>
              <td>6</td>
              <td>Dr. K. Papadopoulos</td>
              <td>1989 – 1990</td>
            </tr>{" "}
            <tr>
              <td>7</td>
              <td>Dr. O.E. Abumere</td>
              <td>1990 – 1992</td>
            </tr>{" "}
            <tr>
              <td>8</td>
              <td>Dr. J.O. Ebeniro</td>
              <td>1992 – 1994</td>
            </tr>{" "}
            <tr>
              <td>9</td>
              <td>Dr. I.O. Owate</td>
              <td>1994 – 1996</td>
            </tr>{" "}
            <tr>
              <td>10</td>
              <td>Dr. O.E. Abumere</td>
              <td>1996 – 1999</td>
            </tr>{" "}
            <tr>
              <td>11</td>
              <td>Prof.C.U.Okujagu</td>
              <td>2001 – 2003</td>
            </tr>{" "}
            <tr>
              <td>12</td>
              <td>Prof. T.M. Abbey</td>
              <td>2003 – 2006</td>
            </tr>{" "}
            <tr>
              <td>13</td>
              <td>Dr. G.O. Avwiri</td>
              <td>2006 – 2008</td>
            </tr>{" "}
            <tr>
              <td>14</td>
              <td>Prof. O.E. Abumere</td>
              <td>2008 – 2010</td>
            </tr>{" "}
            <tr>
              <td>15</td>
              <td>Dr. E.O. Chukwuocha</td>
              <td>2010 – 2012</td>
            </tr>{" "}
            <tr>
              <td>16</td>
              <td>Prof. I.O. Owate</td>
              <td>2012 – 2014</td>
            </tr>{" "}
            <tr>
              <td>17</td>
              <td>Prof. T.M. Abbey</td>
              <td>2014 – 2016</td>
            </tr>{" "}
            <tr>
              <td>18</td>
              <td>Dr. E. Osarolube</td>
              <td>2016 - 2018</td>
            </tr>{" "}
            <tr>
              <td>19</td>
              <td>Dr. Y.E. Chad-Umoren</td>
              <td>2018 – 2020</td>
            </tr>{" "}
            <tr>
              <td>20</td>
              <td>Prof. C.N. Ehirim</td>
              <td>2020 - 2022</td>
            </tr>{" "}
          </tbody>
        </Table>
      </div>
    </>
  );
};
